import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Referral APIs
//TODO: Referral APIs
//  Referral Create
export const createReferralAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}create-referral`, data, headers);
};
//  Referral Update
export const updateReferralAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}update-referral`, data, headers);
};
//  Referral Delete
export const deleteReferralAPI = async (data) => {
  const headers = createHeaders()
  return await axios.post(`${BASE_URL}delete-referral`, data, headers);
};
//  Referral List
export const listReferralAPI = async (data) => {
  const headers = createHeaders()
  return await axios.get(`${BASE_URL}list-referral`,{ params: data, headers: headers?.headers });
};